
	import {
		BreadcrumbInstance,
		BreadcrumbStructureItem,
		Filter,
		Organization,
	} from '@/interfaces';
	import FederationService from '@/services/FederationService';
	import { defineComponent, inject, onMounted, ref } from 'vue';
	import { useI18n } from 'vue-i18n';
	import { useRoute, useRouter } from 'vue-router';
	import InfiniteScroll from '@/components/UI/InfiniteScroll.vue';
	import { MrUiKitCard, MrUiKitPagination, MrUiKitList } from 'mr-ui-kit';
	import { localizePath } from '@/plugins/i18n';
	import { useStore } from 'vuex';

	export default defineComponent({
		name: 'SportClubList',
		components: {
			MrUiKitCard,
			MrUiKitPagination,
			MrUiKitList,
			InfiniteScroll,
		},
		setup(props) {
			const { t, locale } = useI18n();
			const store = useStore();
			const router = useRouter();
			const route = useRoute();
			const guard = ref(false);
			const entityId = ref<number>(-1);
			const organizations = ref<Organization[]>([]);
			const isLoading = ref<boolean>(false);
			const filter = ref<Filter>({
				limit: 12,
				offset: 0,
			});

			onMounted(() => {
				entityId.value = +route.params.id;
				loadMore();
			});

			const loadMore = async () => {
				if (!isLoading.value) {
					isLoading.value = true;
					const loaded = await FederationService.getSportClubs(
						entityId.value,
						locale.value,
						filter.value,
					);
					organizations.value.push(...loaded);
					isLoading.value = false;

					if (loaded.length === 0) {
						guard.value = true;
					}

					filter.value.limit += 12;
					filter.value.offset += 12;
				}
			};

			const onClick = (organization: Organization) => {
				router.push(
					localizePath({ path: '/organizations/' + organization.id }),
				);

				store.commit('pushBreadcrumb', {
					label: organization.fullname,
					path: '/organizations/' + organization.id,
					type: BreadcrumbStructureItem.Organization,
				});
			};

			return {
				t,
				loadMore,
				onClick,
				guard,
				organizations,
				isLoading,
			};
		},
	});
